
import React from 'react'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'next-i18next'
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons'

type NotificationSpinnerType = 'success' | 'processing' | 'warning' | 'error' | 'default'
interface CustomTagProps extends TagProps {
  text: string,
  type: NotificationSpinnerType | string
  showIcon?: boolean
}

const CustomTag: React.FC<CustomTagProps> = (props) => {
  const { t } = useTranslation()
  const { text, type, showIcon = true, ...restProps } = props

  const getIcon = () => {
    const icons = {
      success: <CheckCircleOutlined />,
      processing: <SyncOutlined spin />,
      error: <CloseCircleOutlined />,
      warning: <ExclamationCircleOutlined />,
      'default': <ClockCircleOutlined />
    }
    return icons[type]
  }

  return (
    <Tag
      icon={showIcon ? getIcon(): null}
      color={type}
      className='radius-100'
      {...restProps}
    >
      {t(text)}
    </Tag>
  )
}

export default CustomTag
